import React from 'react';
import { MessageCircleIcon, LayersIcon, FileSearchIcon, ShieldCheckIcon } from 'lucide-react';
const FeatureItem = ({
  icon,
  title,
  description,
  codeExample,
  imageUrl,
  index
}) => {
  return <div className="bg-slate-900 rounded-xl border border-slate-700 overflow-hidden hover:border-orange-500/50 transition-all duration-300 flex flex-col h-full" data-id="element-61">
      <div className="p-6 border-b border-slate-700" data-id="element-62">
        <div className="flex items-start gap-4" data-id="element-63">
          <div className="bg-orange-500/10 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-64">
            {icon}
          </div>
          <div className="flex-1" data-id="element-65">
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-66">{title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-67">
              {description}
            </p>
          </div>
        </div>
      </div>
      <div className="p-6 bg-slate-950 flex-1 flex flex-col" data-id="element-68">
        {/* Code Example */}
        <div className="mb-4" data-id="element-69">
          <div className="flex items-center justify-between mb-2" data-id="element-70">
            <span className="text-xs text-slate-400 font-mono" data-id="element-71">schema.ts</span>
          </div>
          <pre className="bg-slate-900 rounded-lg p-4 overflow-x-auto border border-slate-700" data-id="element-72">
            <code className="text-sm font-mono text-slate-300" data-id="element-73">
              {codeExample}
            </code>
          </pre>
        </div>
        {/* Image with fixed height */}
        <div className="flex-1 flex items-center justify-center" data-id="element-74">
          {imageUrl ? <div className="bg-slate-800 rounded-lg border border-slate-700 overflow-hidden w-full" data-id="element-75">
              <img src={imageUrl} alt={title} className="w-full h-[280px] object-cover object-top" data-id="element-76" />
            </div> : <div className="bg-slate-800 rounded-lg border border-slate-700 w-full h-[280px] flex items-center justify-center" data-id="element-77">
              <p className="text-slate-500 text-sm" data-id="element-78">Image placeholder</p>
            </div>}
        </div>
      </div>
    </div>;
};
const Features = () => {
  const features = [{
    icon: <MessageCircleIcon size={24} className="text-orange-500" data-id="element-79" />,
    title: 'Multi-Modal Inputs',
    description: 'Users can type, speak, upload files, or use their camera. All inputs are processed through the same schema with AI validation.',
    codeExample: `const config = {
  AIChatInput: true,
  documentInput: true,
  voiceInput: true,
  cameraInput: true
}`,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4cSJq1TzM2DqvY3Xif3daF/MultimodalInputs.mp4_%281%29.png'
  }, {
    icon: <LayersIcon size={24} className="text-orange-500" data-id="element-80" />,
    title: 'Schema-First, Multi-Channel Compatible',
    description: 'Define your data structure once. Deploy across web, Slack, WhatsApp, and more. FluidForm handles validation, UI generation, and AI-powered interactions automatically.',
    codeExample: `const config = {
  whatsapp: true
}`,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fskLE8c7ioEVZs3d3mZJV5/Screenshot_2025-11-09_at_12.16.50_PM.png'
  }, {
    icon: <FileSearchIcon size={24} className="text-orange-500" data-id="element-81" />,
    title: 'Accurate Information Extraction and Mapping',
    description: 'Upload PDFs, images, or handwritten forms. AI extracts structured data and maps it to your schema automatically with high accuracy.',
    codeExample: `const config = {
  aiExtract: true,
  aiMapping: true
}`,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pewuyrdyHEzHbE3KVDHahQ/pdffFileInputExtraction.png'
  }, {
    icon: <ShieldCheckIcon size={24} className="text-orange-500" data-id="element-82" />,
    title: 'AI Validation Agents',
    description: 'Define validation rules in natural language. AI agents understand context, ask clarifying questions, and ensure data quality.',
    codeExample: `const schema = {
  address: {
    type: 'address',
    validation: {
      ai: 'make sure the address is complete'
    }
  }
}`,
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qkGCiV5StfRYMzVZ3mEcnD/AIValidation.png'
  }];
  return <section className="w-full bg-slate-950 py-24 border-t border-slate-800" id="features" data-id="element-83">
      <div className="container mx-auto px-4" data-id="element-84">
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-86">
            Built for Developers
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-87">
            Schema-driven architecture with AI-powered capabilities. Write less
            code, ship faster.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto" data-id="element-88">
          {features.map((feature, index) => <FeatureItem key={index} icon={feature.icon} title={feature.title} description={feature.description} codeExample={feature.codeExample} imageUrl={feature.imageUrl} index={index} data-id="element-89" />)}
        </div>
      </div>
    </section>;
};
export default Features;